module.exports = __webpack_public_path__ + "static/img/30011 (4).35f585f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30011 (4).webp
// module id = pORc
// module chunks = 14